<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center" no-gutters>
      <v-col>
        <v-card class="mx-auto" max-width="450">
          <v-img class="aling-center" src="../../assets/img/ORCID_BANNER.png" />
          <v-card-text class="text--primary center headline">
            <div v-if="sess">Login Exitoso</div>
            <div v-else>Login fallido</div>
          </v-card-text>
          <v-card-actions class="text-center align-center">
            <v-row justify="center">
              <v-btn rounded color="light-blue" @click="closeWindow()">
                Aceptar
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import firebase from "firebase";

export default {
  data() {
    return {
      data: [],
      sess: this.$store.getters.getSession
    };
  },
  computed: {},

  methods: {
    ...mapMutations(["login", "insertCode"]),
    ...mapActions(["login", "requestToken"]),
    closeWindow() {
      window.close();
    },
    refreshParentPage() {
      window.onbeforeunload = () => {
        window.opener.location.replace("http://localhost:8080/projects");
      };
    },
    firebaseLogin() {
      this.data = this.$store.getters.getToken;
      // eslint-disable-next-line no-console
      if (this.data[0]["tokenFirebase"] && this.data[1]["tokenOrcid"]) {
        // eslint-disable-next-line no-console
        firebase
          .auth()
          .signInWithCustomToken(this.data[0]["tokenFirebase"])
          .then(() => {
            // eslint-disable-next-line no-console
            console.log("Login exitoso");
          })
          // eslint-disable-next-line no-console
          .catch(res => {
            // eslint-disable-next-line no-console
            console.log(`Ha ocurrido algo mal: ${res}`);
          });
      }
    }
  },
  created() {
    this.insertCode(this.$route.query.code);
    this.requestToken();
    this.refreshParentPage();
  },
  mounted() {
    this.$nextTick(function() {
      this.$store.watch(
        (state, getters) => getters.getSession,
        (newValue, oldValue) => {
          // eslint-disable-next-line no-console
          console.log(`Updating from ${oldValue} to ${newValue}`);
          if (newValue) {
            this.firebaseLogin();
            this.sess = newValue;
          }
        }
      );
    });
  }
};
</script>

<style></style>
